import React, { Component } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import "./Spacing.css";

export class Home extends Component {
  static displayName = Home.name;

    constructor(props) {
        super(props);

        this.props.showHostingNav(true);
    }

  render () {
    return (
        <Container>
            <Row>
                <Col><p className="space-bottom"></p></Col>
            </Row>
            <Row>
                <Col className="hidden-md"></Col>
                <Col lg="6">
                    <Button color="primary" size="lg" block tag={Link}  to='/play'>Spielen</Button>
                </Col>
                <Col className="hidden-md"></Col>
            </Row>
            <Row>
                <Col><p className="space-top space-bottom"></p></Col>
            </Row>
            <Row>
                <Col className="hidden-md"></Col>
                <Col lg="6">
                    <Button color="primary" size="lg" block tag={Link} to="/results">Resultate</Button>
                </Col>
                <Col className="hidden-md"></Col>
            </Row>
        </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Home.jsx